<div class="content-wrapper reports-container">
  <!-- Content Header (Page header) -->
  <div
    class="col-md-12 layout-spacing widget quick-category"
    style="margin-top: 19px"
  >
    <a class="widget quick-category">
      <div class="quick-category-head">
        <h5 class="card-title">{{ 'record.filter.title' | translate }}</h5>
        <div class="ml-auto">
          <button
            *ngIf="!areFiltersCollapsed"
            class="btn quick-comparison qcompare-success"
            (click)="areFiltersCollapsed = !areFiltersCollapsed"
          >
            <span>{{ 'record.filter.contract' | translate }}</span>
            <i class="las la-arrow-up"></i>
          </button>
          <button
            *ngIf="areFiltersCollapsed"
            class="btn quick-comparison qcompare-success"
            (click)="areFiltersCollapsed = !areFiltersCollapsed"
          >
            <span>{{ 'record.filter.advancedSearch' | translate }}</span>
            <i class="las la-arrow-down"></i>
          </button>
        </div>
      </div>
      <div class="quick-category-content">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.startDate' | translate }}
              </h6>
              <div>
                <input
                  bsDatepicker
                  [(ngModel)]="minDate"
                  readonly
                  class="form-control flatpickr flatpickr-input active"
                  type="text"
                  placeholder="{{ 'record.filter.selectDate' | translate }}"
                  [bsConfig]="{
                    isAnimated: true,
                    containerClass: 'theme-dark-blue',
                    dateInputFormat: 'DD-MM-YYYY'
                  }"
                  [maxDate]="maxDate"
                />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.endDate' | translate }}
              </h6>
              <div>
                <input
                  bsDatepicker
                  [(ngModel)]="maxDate"
                  readonly
                  class="form-control flatpickr flatpickr-input active"
                  type="text"
                  placeholder="{{ 'record.filter.selectDate' | translate }}"
                  [bsConfig]="{
                    isAnimated: true,
                    containerClass: 'theme-dark-blue',
                    dateInputFormat: 'DD-MM-YYYY'
                  }"
                  [minDate]="minDate"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row" [ngbCollapse]="areFiltersCollapsed">
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'utilities.filters.fileName' | translate }}
              </h6>
              <div>
                <input
                  [(ngModel)]="fileName"
                  class="form-control"
                  placeholder="{{ 'record.filter.fileName' | translate }}"
                  type="text"
                  id="example-text-input"
                />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">{{ 'record.filter.user' | translate }}</h6>
              <div>
                <input
                  [(ngModel)]="user"
                  class="form-control"
                  placeholder="{{ 'record.filter.email' | translate }}"
                  type="text"
                  id="example-text-input"
                />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'utilities.filters.location' | translate }}
              </h6>
              <ng-select
                class="selectpicker"
                [placeholder]="'utilities.filters.location' | translate"
                [items]="locations"
                [closeOnSelect]="false"
                [(ngModel)]="selectedLocations"
              ></ng-select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'utilities.filters.label' | translate }}
              </h6>
              <ng-select
                class="selectpicker"
                [placeholder]="'utilities.filters.label' | translate"
                [items]="labelsName"
                bindLabel="name"
                bindValue="id"
                [closeOnSelect]="false"
                [(ngModel)]="selectedLabels"
              ></ng-select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'utilities.filters.sensitivyData' | translate }}
              </h6>
              <div class="checkbox-wrapper-13 ml-3">
                <input id="c1-13" type="checkbox" [(ngModel)]="checkboxSi" />
                <label for="c1-13">{{
                  'utilities.filters.yes' | translate
                }}</label>

                <input
                  id="c1-14"
                  class="ml-3"
                  type="checkbox"
                  [(ngModel)]="checkboxNo"
                />
                <label for="c1-14">{{
                  'utilities.filters.no' | translate
                }}</label>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'utilities.filters.department' | translate }}
              </h6>
              <ng-select
                class="selectpicker"
                [placeholder]="'utilities.filters.department' | translate"
                [items]="departments"
                bindLabel="name"
                bindValue="id"
                [closeOnSelect]="false"
                [(ngModel)]="selectedDeptos"
              ></ng-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="btn-filtros">
              <button
                style="padding: 5px 30px; width: 110px"
                type="button"
                class="btn btn-primary"
                (click)="setFilters()"
              >
                {{ 'record.filter.filter' | translate }}
              </button>
              <button
                style="padding: 5px 0px; width: 110px"
                type="button"
                class="btn btn-outline-primary"
                (click)="cleanFilters()"
              >
                {{ 'record.filter.cleanFilters' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </a>

    <div class="row">
      <div class="col-md-12 d-flex align-items-center">
        <div class="btn-informes">
          <button
            style="
              padding: 5px 25px;
              width: 165px;
              height: 35px;
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 6px;
            "
            id="btnGroupVerticalDropdown"
            type="button"
            class="btn btn-primary dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="icon download-button" style="height: 17px"></i>
            {{ 'record.download.download' | translate }}
            <i class="las la-angle-down"></i>
          </button>
          <div class="dropdown-menu" aria-labelledby="btnGroupVerticalDropdown">
            <button class="dropdown-item" (click)="generateGeneralIrmReport()">
              <i class="icon download-type"></i>
              {{ 'record.download.overviewReport' | translate }}
            </button>
          </div>
          <!-- 
            <button
            style="
              padding: 5px;
              width: 100px;
              height: 35px;
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 6px;
            "
              type="button"
              class="btn btn-outline-primary"
            >
              <i class="icon excel" style="height: 17px"></i>
              {{ 'record.exportToExcel' | translate }}
            </button>
          -->
        </div>
        <div>
          {{
            'record.recordsCount'
              | translate
                : {
                    count: reports?.length || '0',
                    total: collectionSize || '0'
                  }
          }}
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center loader" *ngIf="isLoading">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <form>
      <table class="table table-striped">
        <thead>
          <tr>
            <th style="width: 200px" scope="col">
              {{ 'utilities.table.fileName' | translate }}
            </th>
            <th scope="col">
              {{ 'utilities.table.owner' | translate }}
            </th>
            <th scope="col">
              {{ 'utilities.table.department' | translate }}
            </th>
            <th scope="col">
              {{ 'utilities.table.label' | translate }}
            </th>
            <th scope="col">
              {{ 'utilities.table.location' | translate }}
            </th>
            <th scope="col" sortable="modificationDate" (sort)="onSort($event)">
              {{ 'utilities.table.lastModification' | translate }}
            </th>
            <th scope="col">
              {{ 'record.table.opt' | translate }}
            </th>
          </tr>
        </thead>
        <tbody *ngIf="!isLoading">
          <tr *ngFor="let report of reports">
            <td
              data-toggle="tooltip"
              placement="top"
              animation="true"
              container="body"
              [openDelay]="300"
              [closeDelay]="300"
              ngbTooltip="{{ report.fileName }}"
            >
              {{ cutString(report.fileName) }}
            </td>
            <td>{{ report.ownerUser }}</td>
            <td>{{ report.department }}</td>
            <td>{{ report.label }}</td>
            <td>{{ report.location }}</td>
            <td>{{ formatDateTable(report.modificationDate) }}</td>
            <td>
              <button
                (click)="seeDetails(report.id)"
                style="border: none; padding: 0; background: transparent"
              >
                <i class="las la-eye font-25"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div
        *ngIf="reports?.length <= 0 && !isLoading"
        class="d-flex justify-content-center"
      >
        <span>{{ 'noDataAvailable' | translate }}</span>
      </div>
    </form>
  </div>

  <div
    class="d-flex justify-content-center p-2 paginator-container"
    *ngIf="reports?.length > 0"
  >
    <div class="items-per-page-container">
      <label for="pageSizeSelect" class="mr-2 mb-0">{{
        'record.filter.itemsPerPage' | translate
      }}</label>
      <select
        id="pageSizeSelect"
        class="form-control"
        style="width: auto; display: inline-block"
        [(ngModel)]="pageSize"
        (change)="refreshReports()"
      >
        <option [ngValue]="10">10</option>
        <option [ngValue]="20">20</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <ngb-pagination
      [collectionSize]="collectionSize / 2"
      [(page)]="page"
      [pageSize]="pageSize"
      [rotate]="true"
      [maxSize]="5"
      [ellipses]="false"
      [boundaryLinks]="true"
      (pageChange)="refreshReports()"
    >
    </ngb-pagination>
  </div>
</div>
